export const footer = {
  socialNetworks: {
    background: "#FDCB6E",
    color: "rgba(108, 92, 231, 1)"
  }
};